"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var Camera = function Camera(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className, " d8-svg-").concat(name),
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "\uD83C\uDFA8-Icon-Color",
    transform: "translate(2.000000, 4.000000)",
    fill: fill
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2.97007,3 L5.8335,3 L7.50016,0.5 L12.5002,0.5 L14.1668,3 L17.0303,3 C17.7732,3 18.0426,3.07735 18.3142,3.22261 C18.5858,3.36787 18.799,3.58102 18.9442,3.85263 C19.0895,4.12423 19.1668,4.39364 19.1668,5.13657 L19.1668,13.3634 C19.1668,14.1064 19.0895,14.3758 18.9442,14.6474 C18.799,14.919 18.5858,15.1321 18.3142,15.2774 C18.0426,15.4226 17.7732,15.5 17.0303,15.5 L2.97007,15.5 C2.22713,15.5 1.95773,15.4226 1.68612,15.2774 C1.41452,15.1321 1.20136,14.919 1.05611,14.6474 C0.910851,14.3758 0.833496,14.1064 0.833496,13.3634 L0.833496,5.13657 C0.833496,4.39364 0.910851,4.12423 1.05611,3.85263 C1.20136,3.58102 1.41452,3.36787 1.68612,3.22261 C1.95773,3.07735 2.22713,3 2.97007,3 Z M8.3335,8.83333 C8.3335,7.90936 9.07619,7.16667 10.0002,7.16667 C10.9241,7.16667 11.6668,7.90936 11.6668,8.83333 C11.6668,9.7573 10.9241,10.5 10.0002,10.5 C9.07619,10.5 8.3335,9.7573 8.3335,8.83333 Z M6.66683,8.83333 C6.66683,10.6778 8.15572,12.1667 10.0002,12.1667 C11.8446,12.1667 13.3335,10.6778 13.3335,8.83333 C13.3335,6.98889 11.8446,5.5 10.0002,5.5 C8.15572,5.5 6.66683,6.98889 6.66683,8.83333 Z",
    id: "Shape"
  }))));
};
Camera.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
Camera.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = Camera;